import React, { useEffect, useRef, useState } from 'react';
import * as signalR from "@microsoft/signalr";
import axios from "axios";
import './Meters.css';
import './BusBars.css';
import click from './sounds/shortclick.mp3';
import switchboardWLPT from './images/WaterLeakageMainSwitchBoardWLS.jpg';


const BoardWidth = 1475;  //YF:1475, YC: 1725

// A custom component that displays an image
function SwitchBoardWLImage(props) {
    return (
        <div className="estate-image" align-items="center">
            < img src={props.src} alt={props.alt} width={BoardWidth} />
        </div>
    );
}

export default function SwitchBoardWL() {

    const [dev, setDev] = useState([]);
    const [displaydev, setDisplsyDev] = useState([]);
    const [retry, setRetry] = useState(false);
    const [hoveredCell, setHoveredCell] = useState(false);
    const [isLoading, setIsLoading] = useState(true);
    const [buildingId, setBuildingId] = useState(3);
    const [switchBoardImage, setSwitchBoardImage] = useState(switchboardWLPT);

    const [pins, setPins] = useState([]);

    const playClickSound = () => {
        const audio = new Audio(click);
        audio.play();
        audio.onended = () => { }
    };

    // Handle button click
    function handleClick(e) {
        console.log("Button clicked with value:", e); // Add this line
        playClickSound();
        setBuildingId(e);
        let scaledPin_2 = dev
            .filter(device => device.id > 123 && device.id < 161)
            .filter(device => device.mapx !== null && device.mapy !== null)
            .filter(device => device.buildingId === e)
            .map(device => {
                return { ...device, x: device.mapx, y: device.mapy };
            });
        // Set the pins state with the coordinates
        setPins(scaledPin_2);
        switch (e) {
            case 1:
                setSwitchBoardImage(switchboardWLPT);
                break;


            default:
                break;
        }
        let filteredDev = dev.filter(d => d.channel === e);
        setDisplsyDev(filteredDev);
    };


    const PinIcon = ({ x, y, info, delay }) => {
        const [isHovered, setIsHovered] = useState(false);
        const [isDropped, setIsDropped] = useState(false);

        useEffect(() => {
            // Trigger the drop animation after the specified delay
            const timer = setTimeout(() => {
                setIsDropped(true);
            }, delay);

            return () => clearTimeout(timer);
        }, [delay]);

        return (
            <div
                style={{
                    position: "absolute",
                    left: `${x}px`,
                    top: isDropped ? `${y}px` : "-50px",
                    transform: "translate(-50%, -50%)",
                    zIndex: 5, // ← Lower than buttons
                    pointerEvents: "auto", // ← Enable hover on pins
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                    cursor: "pointer",
                    transition: `top 0.5s cubic-bezier(0.175, 0.885, 0.32, 1.275) ${delay}ms`, // Bounce effect
                }}
                onMouseEnter={() => setIsHovered(true)}
                onMouseLeave={() => setIsHovered(false)}
            >
                {/* Rest of your PinIcon code remains the same */}
                <div style={{
                    width: "12px",
                    height: "12px",
                    borderRadius: "50%",
                    backgroundColor: isHovered ? "#ff0000" : "#ff5252",
                    border: "2px solid white",
                    boxShadow: "0 0 0 2px rgba(255,0,0,0.5)",
                    transition: "all 0.2s ease",
                    transform: isHovered ? "scale(1.3)" : "scale(1)",
                }} />

                <div style={{
                    position: "relative",
                    /*backgroundColor: "rgba(0, 0, 255, 1)",*/
                    backgroundColor: "rgba(0, 0, 255, 0)",
                    borderRadius: "4px",
                    padding: isHovered ? "6px 10px" : "2px 6px",
                    fontSize: isHovered ? "28px" : "14px",
                    fontWeight: "bold",
                    color: "#FFFFFF",
                    boxShadow: "0 2px 4px rgba(0,0,0,0.2)",
                    whiteSpace: "nowrap",
                    transition: "all 0.2s ease",
                    opacity: isHovered ? 1 : 1,
                    transform: isHovered ? "translateY(0)" : "translateY(5px)",
                    marginTop: "8px",
                }}>
                    { }
                    <div style={{
                        position: "absolute",
                        top: "-6px",
                        left: "50%",
                        transform: "translateX(-50%)",
                        width: 0,
                        height: 0,
                        borderLeft: "6px solid transparent",
                        borderRight: "6px solid transparent",
                        borderBottom: "6px solid rgba(255, 255, 255, 0.9)",
                    }} />
                </div>
            </div>
        );
    }

    const ImageWithPins = ({ pins }) => {
        return (
            <div style={{
                position: "absolute",
                top: 0,
                left: 0,
                width: "100%",
                height: "100%",
                pointerEvents: "none", // ← Disable pointer events on container
            }}>
                {pins.map((pin, index) => (
                    <PinIcon
                        key={index}
                        x={pin.x + 12}
                        y={pin.y + 36}
                        info={`${pin.data}°C`}
                        delay={index * 30 + 1000}
                    />
                ))}
            </div>
        );
    };

    useEffect(() => {

        console.log("Updating web page...");
        const httpClient = axios.create({
            baseURL: 'https://futipiot.ddns.net', // The base URL of your web application
            headers: {
                'Content-Type': 'application/json'
            }
        });

        // Call the web API endpoint with GET method
        const getData = async () => {
            setIsLoading(true);
            await httpClient.get('/api/meters')
                .then((response) => {
                    const deviceDetails = response.data.map((item) => ({
                        id: item.deviceId,
                        deviceName: item.deviceName,
                        deviceEui: item.deviceEui,
                        label: item.label,
                        status: item.status,
                        mapx: item.mapx === null ? null : item.mapx * BoardWidth / 1475,
                        mapy: item.mapy === null ? null : item.mapy * BoardWidth / 1475,
                        logic: item.type,
                        data_type: item.dataType,
                        alive: item.alive,
                        data: item.data,
                        channel: item.channel,
                        unit: item.unit,
                        modbusId: item.modbusId,
                        buildingId: item.buildingId
                    }));

                    let scaledPin_2 = deviceDetails
                        .filter(device => device.id > 145 && device.id < 163
                        )
                        .filter(device => device.mapx !== null && device.mapy !== null)
                        .map(device => {
                            return { ...device, x: device.mapx, y: device.mapy };
                        });
                    // Set the pins state with the coordinates
                    setPins(scaledPin_2);

                    let filteredDev = deviceDetails.filter(d => (d.modbusId > 99) && (d.modbusId < 124));

                    setDisplsyDev(filteredDev);
                    setDev(deviceDetails);

                    console.log("Displadev");
                    console.log(response);
                    setIsLoading(false);
                })
                .catch(error => {

                    // Handle the error
                    console.error(error);
                    setRetry(true);
                });
        };

        getData();

    }, [retry]);

    function DList() {

        return (
            <div>
                <tr className="row">
                    <td style={{ verticalAlign: "top", width: "572px" }}>
                        <table style={{ verticalAlign: "top" }} >
                            <tr>
                                {!isLoading && (
                                    //<div className="boardpin" >
                                    <div style={{ position: "relative", display: "inline-block" }}> 
                                        <SwitchBoardWLImage
                                            src={switchBoardImage}
                                        />
                                        <ImageWithPins pins={pins} />
                                    </div>
                                )}
                            </tr>
                        </table>
                    </td>
                </tr>
            </div>
        );

    };

    return (
        <div className="containerstyle">
            <table>
                <td >

                    <div >
                        <table>
                            <tr>
                                <td style={{ verticalAlign: "top", width: "6%", height: "13.4rem" }}>
                                    <div>
                                        <div className="bbuttonstyle" style={{ fontSize: "18px", color: buildingId === 1 ? "#202020" : "#f5f1eb", backgroundColor: buildingId === 1 ? "#BfBfBf" : "#4f4f4f", zIndex: 10, position: "relative" }} onClick={() => handleClick(1)}>
                                            斑蝶樓
                                        </div>
                                    </div>
                                </td>
                                <td style={{ verticalAlign: "top" }}>
                                    <table style={{ fontSize: "12px", verticalAlign: "top", marginTop: "8px", width: "1680px" }}>

                                        <DList />

                                    </table>
                                </td>
                            </tr>
                        </table>
                    </div>
                </td>
            </table>
        </div>
    );


}
